import { Grid } from "@mui/material";
import { ItemTypeCheckbox } from "components/FormControls/ItemTypeCheckbox";
import { aggregationTypes } from "components/Layout/Achievement/helpers";
import { useMessage } from "hooks/intl";
import {
  AchievementAggregationUnion,
  AchievementTriggersUnion,
  FEAvailableAchievementAggregationType,
} from "types/achievements";

interface Props {
  aggregation: AchievementAggregationUnion;
  setFieldValue: (field: string, value: any) => void;
  activeRule: number;
  trigger: AchievementTriggersUnion;
}

export const RuleCounting = ({
  aggregation,
  setFieldValue,
  activeRule,
  trigger,
}: Props) => {
  const { message } = useMessage();
  return (
    <Grid container spacing={12} mt={-10}>
      {aggregationTypes.map((item: FEAvailableAchievementAggregationType) => (
        <Grid item xs={6} key={item.aggregation}>
          <ItemTypeCheckbox
            data-test-id={`rule-${activeRule}-counting-${item.aggregation}`}
            activeItem={aggregation === item.aggregation}
            label={message({ id: item.label })}
            description={message({ id: item.descriptionText(trigger) })}
            onClick={() => {
              setFieldValue(
                `rules[${activeRule}].aggregation.type`,
                item.aggregation,
              );
              setFieldValue(
                `rules[${activeRule}].completeRule.onlyUniqueAttributeValues`,
                undefined,
              );
              setFieldValue(
                `rules[${activeRule}].completeRule.uniqueAttribute`,
                undefined,
              );
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
};
